module.exports = __webpack_public_path__ + "static/media/cedarmillVertical.8a89e50b.png";